import styles from './rentrollgraph.module.css';
import { styled } from '@mui/material/styles';
import { Tooltip } from '@mui/material';
import { tooltipClasses } from '@mui/material/Tooltip';
import { Doughnut } from 'react-chartjs-2';
import { useAuth0 } from '@auth0/auth0-react';
import { useState } from 'react';
import { useEffect } from 'react';
import axios from "axios";

const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
        fontSize: 13,
    },
}));

const BGColor = [
    "#00BFFF",
    "#32CD32",
    "#FFC107",
    "#DC143C",
    "#FFDAB9",
    "#40E0D0",
    "#FFA07A",
    "#0027ED",
    "#F6FF00",
    "#FF69B4",
];

const RentRollGraph = ({ selectedIds }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [chartData, setChartData] = useState(null);
    const [chartData2, setChartData2] = useState({
        labels: [],
        datasets: [
            { data: [], backgroundColor: [], borderColor: [], borderWidth: 1 },
        ],
    });

    useEffect(() => {
        async function getLeases() {
            if (selectedIds) {
                const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

                let params = {};

                params = { ...params, apt_ids: selectedIds?.join() };

                await axios(process.env.REACT_APP_USER_API_URL + "v1/report/rent-chart-data", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: params,
                }).then((response) => {
                    setChartData(response.data.data);
                }).catch((error) => { });
            }
        }
        getLeases();
    }, [getAccessTokenSilently, selectedIds]);

    const options = {
        legend: {
            display: false,
        },
        tooltip: {
            display: false,
        },
        maintainAspectRatio: false,
        cutoutPercentage: 75,
        responsive: true,
    }

    useEffect(() => {
        if (chartData) {
            if (chartData?.properties.length > 0) {
                let labels = chartData?.properties?.map((i) => i?.title);
                let cdata = chartData?.properties?.map((i) => i?.total);
                let bg = chartData?.properties?.map((_, i) => BGColor[i]);
                let border = chartData?.properties?.map((_, i) => BGColor[i]);

                setChartData2({
                    labels: labels,
                    datasets: [
                        {
                            data: cdata,
                            backgroundColor: bg,
                            borderColor: border,
                            borderWidth: 1,
                        },
                    ],
                });
            }
        }
    }, [chartData]);

    return (chartData && (<>
        {chartData?.total > 0 && (<>
            <div className={`${styles.ChartMainSec}`}>
                <div className={`${styles.TotalIncomeSec}`}>
                    <p className={`${styles.Text2}`}>Total Units: {chartData?.total}</p>
                    <p className={`${styles.Text2}`}>Occupied: {chartData?.occupied}</p>
                    <p className={`${styles.Text2}`}>Vacant: {chartData?.vacant}</p>
                    <p className={`${styles.Text2}`}>Occupancy Rate: {chartData?.occupancy_rate}%</p>
                </div>
                <div className={`${styles.ChartSec}`}>
                    <Doughnut data={chartData2} options={options} />
                </div>
            </div>
            <div className={`${styles.ChartListCatMain}`}>
                {chartData && chartData?.properties?.map((c, i) => {

                    return <div className={`${styles.ChartListCat}`}>
                        <p>{c?.title} <span>{c?.total}</span></p>
                        <div className={`${styles.ChartProgressTrack}`}>
                            <BootstrapTooltip title={(<div className={`${styles.IncomeLineTooltip}`}>
                                <p>Total Occupied: {c?.occupied}</p>
                            </div>)}>
                                <div style={{ width: `${100 - c?.vacantPercentage}%`, backgroundColor: BGColor[i] }}></div>
                            </BootstrapTooltip>

                            <BootstrapTooltip title={(<div className={`${styles.IncomeLineTooltip}`}>
                                <p>Total Vacant: {c?.vacant}</p>
                            </div>)}>
                                <div style={{ width: `${c?.vacantPercentage}%`, backgroundColor: BGColor[i], cursor: 'pointer', filter: 'brightness(0.75)' }}></div>
                            </BootstrapTooltip>
                        </div>
                    </div>

                })}
            </div >
        </>)}

        {
            chartData?.total === 0 &&
            <div className={`${styles.NoDataMain}`}>
                <div className={`${styles.NoDataIMG}`}>
                    <img src="/static/img/no-report.png" alt="No Data" />
                </div>
                <p className={`${styles.NoDataText}`}>Empty!</p>
                <p className={`${styles.NoDataTextSub}`}>Looks like no unit have been added</p>
            </div>
        }
    </>)
    );
}

export default RentRollGraph;